import React from 'react'
import { Card, CardContent, Typography, Grid } from '@mui/material'
import { Icon as IconifyIcon } from "@iconify/react"
import './ConsensusOverview.scss'

export default function ConsensusOverview({ stats }) {
    if (!stats) {
        return null
    }

    const statCards = [
        {
            title: 'Multi-Labor Einreichungen',
            value: stats.multiLabVariants || 0,
            subtitle: `${stats.totalUniqueVariants || 0} Varianten gesamt`,
            percentage: stats.totalUniqueVariants > 0
                ? ((stats.multiLabVariants / stats.totalUniqueVariants) * 100).toFixed(1) + '%'
                : '0%',
            icon: 'mdi:hospital-building',
            color: '#1976d2',
            description: 'Von 2+ Laboren klassifiziert'
        },
        {
            title: 'Konsensus-Rate',
            value: stats.consensusRate ? stats.consensusRate.toFixed(1) + '%' : '0%',
            subtitle: `${stats.consensusVariants || 0} Varianten`,
            benchmark: 'Ziel: 87% (VKGL)',
            icon: 'mdi:check-circle-outline',
            color: stats.consensusRate >= 87 ? '#2e7d32' : '#f57c00',
            description: 'Alle Labore stimmen überein'
        },
        {
            title: 'Kein Konsensus',
            value: stats.noConsensusVariants || 0,
            subtitle: stats.multiLabVariants > 0
                ? ((stats.noConsensusVariants / stats.multiLabVariants) * 100).toFixed(1) + '%'
                : '0%',
            benchmark: 'Ziel: ~12.5% (VKGL)',
            icon: 'mdi:help-circle-outline',
            color: '#ed6c02',
            description: 'VUS gemischt mit P/LP oder B/LB'
        },
        {
            title: 'Konflikt',
            value: stats.conflictingVariants || 0,
            subtitle: stats.conflictingRate ? stats.conflictingRate.toFixed(2) + '%' : '0%',
            benchmark: 'Ziel: <0.5% (VKGL)',
            icon: 'mdi:alert-circle-outline',
            color: stats.conflictingRate <= 0.5 ? '#2e7d32' : '#d32f2f',
            description: 'Pathogen vs. Benign Klassifikation'
        }
    ]

    return (
        <Grid container spacing={3} className="consensus-overview">
            {statCards.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <Card className="consensus-stat-card">
                        <CardContent>
                            <div className="stat-header">
                                <IconifyIcon
                                    icon={stat.icon}
                                    className="stat-icon"
                                    style={{ color: stat.color }}
                                />
                                <Typography variant="subtitle2" className="stat-title">
                                    {stat.title}
                                </Typography>
                            </div>
                            <Typography variant="h3" className="stat-value" style={{ color: stat.color }}>
                                {typeof stat.value === 'number'
                                    ? stat.value.toLocaleString('de-DE')
                                    : stat.value
                                }
                            </Typography>
                            <Typography variant="body2" className="stat-subtitle">
                                {stat.subtitle}
                            </Typography>
                            {stat.benchmark && (
                                <Typography variant="caption" className="stat-benchmark">
                                    {stat.benchmark}
                                </Typography>
                            )}
                            <Typography variant="caption" className="stat-description">
                                {stat.description}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}
